import clsx from "clsx";

import {
  SALE_EXTENSION_SUBTEXT_SHORT,
  SALE_TITLE,
} from "@musicfy/contants/Sale";

interface ISaleOfferHeadingProps {
  title?: string;
  className?: string;
  titleClassName?: string;
  extensionClassName?: string;
  showExtension?: boolean;
  /** Override the default short deadline sub-line. */
  extensionText?: string;
}

const SaleOfferHeading = ({
  title = SALE_TITLE,
  className,
  titleClassName,
  extensionClassName,
  showExtension = true,
  extensionText = SALE_EXTENSION_SUBTEXT_SHORT,
}: ISaleOfferHeadingProps): JSX.Element => {
  return (
    <div className={clsx("flex flex-col", className)}>
      <span className={titleClassName}>{title}</span>
      {showExtension && (
        <span className={clsx("italic text-white/75", extensionClassName)}>
          {extensionText}
        </span>
      )}
    </div>
  );
};

export default SaleOfferHeading;
